"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createEnvironment;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _relayRuntime = require("relay-runtime");

var _createRelayStore = _interopRequireDefault(require("./createRelayStore"));

var _createRequestHandler = _interopRequireDefault(require("./createRequestHandler"));

var _RelayLogger = _interopRequireDefault(require("./RelayLogger"));

var _excluded = ["fetchFn", "subscribeFn", "records", "gcReleaseBufferSize"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function createNetwork(fetchFn, subscribeFn) {
  var fetch = (0, _createRequestHandler.default)(fetchFn);
  return _relayRuntime.Network.create(fetch, subscribeFn);
}

function createEnvironment(options) {
  var fetchFn = options.fetchFn,
      subscribeFn = options.subscribeFn,
      records = options.records,
      gcReleaseBufferSize = options.gcReleaseBufferSize,
      rest = (0, _objectWithoutProperties2.default)(options, _excluded);
  return new _relayRuntime.Environment(_objectSpread({
    network: createNetwork(fetchFn, subscribeFn),
    log: _RelayLogger.default,
    store: (0, _createRelayStore.default)(records, {
      gcReleaseBufferSize: gcReleaseBufferSize
    })
  }, rest));
}